import { render } from "./IconSearchClose.vue?vue&type=template&id=2ad7660c"
import script from "./IconSearchClose.vue?vue&type=script&lang=js"
export * from "./IconSearchClose.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__